import { render } from "./Notifications.vue?vue&type=template&id=cecc8e0c"
import script from "./Notifications.vue?vue&type=script&setup=true&lang=js"
export * from "./Notifications.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/Notifications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cecc8e0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cecc8e0c', __exports__)) {
    api.reload('cecc8e0c', __exports__)
  }
  
  module.hot.accept("./Notifications.vue?vue&type=template&id=cecc8e0c", () => {
    api.rerender('cecc8e0c', render)
  })

}


export default __exports__